import React, { useState } from "react";
import { Menu } from "lucide-react";
import AdminSidebar from "./Components/AdminSidebar";
import ProgramsView from "./Components/Programs/ProgramsView";
import ProgramDetail from "./Components/Programs/ProgramDetail";
import CourseOutcomesView from "./Components/Programs/CourseOutcomesView";

// Admin shell — state-based navigation (not nested routes) for consistency
// with TeacherDashboard. Three levels deep:
//   1. ProgramsView                  (selectedProgramId = null, selectedCourse = null)
//   2. ProgramDetail                 (selectedProgramId set, selectedCourse = null)
//   3. CourseOutcomesView            (selectedCourse set — overrides both)
const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState("Programs");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedProgramId, setSelectedProgramId] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null); // { courseId, courseCode }

  return (
    <div className="flex h-fit min-h-screen dark:bg-gray-900 dark:text-white relative">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(true)}
        className="fixed top-3 left-3 sm:top-4 sm:left-4 z-30 lg:hidden p-2 rounded-sm bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5 sm:h-6 sm:w-6 text-gray-700 dark:text-gray-300" />
      </button>

      <AdminSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isMobileOpen={isMobileMenuOpen}
        setIsMobileOpen={setIsMobileMenuOpen}
      />

      {/* Main Content */}
      <div className="w-full lg:flex-1 lg:ml-0 max-h-screen overflow-y-auto overflow-x-hidden">
        {activeSection === "Programs" &&
          (selectedCourse ? (
            <CourseOutcomesView
              courseId={selectedCourse.courseId}
              courseCode={selectedCourse.courseCode}
              onBack={() => setSelectedCourse(null)}
            />
          ) : selectedProgramId ? (
            <ProgramDetail
              programId={selectedProgramId}
              onBack={() => setSelectedProgramId(null)}
              onSelectCourse={setSelectedCourse}
            />
          ) : (
            <ProgramsView onSelectProgram={setSelectedProgramId} />
          ))}
        {/* Departments / Users / Settings hooked up in later phases */}
      </div>
    </div>
  );
};

export default AdminDashboard;
